import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "affix-sub-header" }
const _hoisted_2 = { class: "ant-table ant-table-bordered" }
const _hoisted_3 = { class: "ant-table-container" }
const _hoisted_4 = { class: "ant-table-content" }
const _hoisted_5 = { style: {"table-layout":"auto"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "ant-table-thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} }, "Ordre"),
    /*#__PURE__*/_createElementVNode("th", null, "Désignation des ouvrages"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "Unité"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "Taux TVA"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"150px"} }, "Prix Unitaire HT"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"330px"} })
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "ant-table-tbody"
}
const _hoisted_8 = { class: "ant-table-placeholder" }
const _hoisted_9 = {
  key: 0,
  class: "ant-table-cell",
  colspan: "9"
}
const _hoisted_10 = {
  key: 1,
  class: "ant-table-cell",
  colspan: "9"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"ant-empty ant-empty-normal\"><div class=\"ant-empty-image\"><svg class=\"ant-empty-img-simple\" width=\"64\" height=\"41\" viewBox=\"0 0 64 41\"><g transform=\"translate(0 1)\" fill=\"none\" fill-rule=\"evenodd\"><ellipse class=\"ant-empty-img-simple-ellipse\" fill=\"#F5F5F5\" cx=\"32\" cy=\"33\" rx=\"32\" ry=\"7\"></ellipse><g class=\"ant-empty-img-simple-g\" fill-rule=\"nonzero\" stroke=\"#D9D9D9\"><path d=\"M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z\"></path><path d=\"M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z\" fill=\"#FAFAFA\" class=\"ant-empty-img-simple-path\"></path></g></g></svg></div><p class=\"ant-empty-description\">No Data</p></div>", 1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["id"]
const _hoisted_14 = {
  class: "ant-table-cell",
  scope: "row"
}
const _hoisted_15 = {
  class: "ant-table-cell",
  scope: "row",
  colspan: "4"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "ant-table-cell" }
const _hoisted_18 = { class: "actions" }
const _hoisted_19 = { class: "actions" }
const _hoisted_20 = ["id"]
const _hoisted_21 = {
  class: "ant-table-cell",
  scope: "row"
}
const _hoisted_22 = { class: "ant-table-cell" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  class: "ant-table-cell",
  scope: "row"
}
const _hoisted_25 = {
  class: "ant-table-cell",
  scope: "row"
}
const _hoisted_26 = {
  class: "ant-table-cell",
  scope: "row"
}
const _hoisted_27 = { class: "ant-table-cell" }
const _hoisted_28 = { class: "actions" }
const _hoisted_29 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_affix = _resolveComponent("a-affix")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_number_format = _resolveComponent("number-format")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_CreateOrUpdateEstimatifLine = _resolveComponent("CreateOrUpdateEstimatifLine")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_set_tva_modal = _resolveComponent("set-tva-modal")!
  const _component_modify_categorie_modal = _resolveComponent("modify-categorie-modal")!
  const _component_price_evolution_modal = _resolveComponent("price-evolution-modal")!
  const _component_move_line_modal = _resolveComponent("move-line-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_affix, { "offset-top": 140 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_row, { type: "flex" }, {
            default: _withCtx(() => [
              (_ctx.categoriesSelected.categorieIdSelected)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 24,
                    align: "right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { onClick: _ctx.openModalAdjustPrice }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ajuster les prix du lot ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_a_button, { onClick: _ctx.openModalTva }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Définir le taux de TVA du lot ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createOrUpdateEstimatifLineDrawer(null)))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_plus_outlined)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" Créer une ligne ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            (_ctx.estimatifLines.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                  _createElementVNode("tr", _hoisted_8, [
                    (_ctx.isLoadingEstimatifLines)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                          _createVNode(_component_a_spin, { size: "large" })
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_10, _hoisted_12))
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_draggable, {
                  key: 1,
                  modelValue: _ctx.estimatifLines,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.estimatifLines) = $event)),
                  dragging: true,
                  tag: "tbody",
                  "item-key": "ordre",
                  "ghost-class": "ghost",
                  onChange: _ctx.updateOrdre,
                  class: "ant-table-tbody",
                  disabled: _ctx.lockDragging
                }, {
                  item: _withCtx(({ element }) => [
                    (element.isPrincipalTitle || element.isSecondaryTitle  || element.isNonChiffrable)
                      ? (_openBlock(), _createElementBlock("tr", {
                          key: 0,
                          id: element.estimatifId,
                          class: _normalizeClass(["ant-table-row ant-table-row-level-0", element.rowClass])
                        }, [
                          _createElementVNode("td", _hoisted_14, [
                            _createElementVNode("span", null, _toDisplayString(element.ordre), 1)
                          ]),
                          _createElementVNode("td", _hoisted_15, [
                            _createElementVNode("div", {
                              innerHTML: element.designation
                            }, null, 8, _hoisted_16)
                          ]),
                          _createElementVNode("td", _hoisted_17, [
                            _createVNode(_component_a_space, { direction: "vertical" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_a_button, {
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.createOrUpdateEstimatifLineDrawer(element))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Modifier ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_a_popconfirm, {
                                    title: "Êtes-vous sûr de vouloir supprimer la ligne ?",
                                    onConfirm: ($event: any) => (_ctx.supprimer(element)),
                                    "ok-text": "Supprimer",
                                    "cancel-text": "Annuler"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        danger: "",
                                        loading: element.estEnCoursSuppression,
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Supprimer ")
                                        ]),
                                        _: 2
                                      }, 1032, ["loading"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  (_ctx.estimatifLines.length > 1)
                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                        key: 0,
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.openModalMoveLine(element))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Déplacer la ligne au n° ")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ], 10, _hoisted_13))
                      : (_openBlock(), _createElementBlock("tr", {
                          key: 1,
                          id: element.estimatifId,
                          class: "ant-table-row ant-table-row-level-0"
                        }, [
                          _createElementVNode("td", _hoisted_21, _toDisplayString(element.ordre), 1),
                          _createElementVNode("td", _hoisted_22, [
                            _createElementVNode("div", {
                              innerHTML: element.designation
                            }, null, 8, _hoisted_23)
                          ]),
                          _createElementVNode("td", _hoisted_24, [
                            _createVNode(_component_a_select, {
                              value: element.uniteId,
                              "onUpdate:value": ($event: any) => ((element.uniteId) = $event),
                              onSelect: ($event: any) => (_ctx.updateEstimatifLine(element))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unites, (unite) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: unite.uniteId,
                                    value: unite.uniteId
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(unite.code), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value", "onSelect"])
                          ]),
                          _createElementVNode("td", _hoisted_25, [
                            _createVNode(_component_a_select, {
                              value: element.tvaId,
                              "onUpdate:value": ($event: any) => ((element.tvaId) = $event),
                              onSelect: ($event: any) => (_ctx.updateEstimatifLine(element))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tvas, (tva) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: tva.tvaId,
                                    value: tva.tvaId
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_number_format, {
                                        value: tva.taux,
                                        options: _ctx.percentageValueOptions
                                      }, null, 8, ["value", "options"])
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value", "onSelect"])
                          ]),
                          _createElementVNode("td", _hoisted_26, [
                            _createVNode(_component_a_input_number, {
                              value: element.prixUnitaire,
                              "onUpdate:value": ($event: any) => ((element.prixUnitaire) = $event),
                              min: 0,
                              precision: 2,
                              "addon-after": "€",
                              controls: false,
                              decimalSeparator: ",",
                              onChange: ($event: any) => (_ctx.updateEstimatifLine(element)),
                              onFocus: _ctx.focus,
                              onBlur: _ctx.blur
                            }, null, 8, ["value", "onUpdate:value", "onChange", "onFocus", "onBlur"])
                          ]),
                          _createElementVNode("td", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_a_button, {
                                size: "small",
                                onClick: ($event: any) => (_ctx.createOrUpdateEstimatifLineDrawer(element))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Modifier ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_a_popconfirm, {
                                title: "Êtes-vous sûr de vouloir supprimer la ligne ?",
                                onConfirm: ($event: any) => (_ctx.supprimer(element)),
                                "ok-text": "Supprimer",
                                "cancel-text": "Annuler"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    danger: "",
                                    loading: element.estEnCoursSuppression,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Supprimer ")
                                    ]),
                                    _: 2
                                  }, 1032, ["loading"])
                                ]),
                                _: 2
                              }, 1032, ["onConfirm"]),
                              _createVNode(_component_a_button, {
                                size: "small",
                                onClick: ($event: any) => (_ctx.openModifyCategorie(element.estimatifId))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Changer de catégorie ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ])
                        ], 8, _hoisted_20))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange", "disabled"]))
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.estimatifLineDrawerIsVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.estimatifLineDrawerIsVisible) = $event)),
      width: "1000px",
      "destroy-on-close": true,
      footer: null
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", _hoisted_29, _toDisplayString(_ctx.estimatifLineToUpdate ? "Modification de la ligne" : "Création d'une nouvelle ligne"), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_CreateOrUpdateEstimatifLine, {
          "estimatif-line": _ctx.estimatifLineToUpdate,
          "categories-selected": _ctx.categoriesSelected,
          tvas: _ctx.tvas,
          unites: _ctx.unites,
          onAddToLines: _ctx.addToLines,
          onUpdateEstimatifLine: _ctx.updateEstimatifLineEdition,
          onClose: _ctx.closeEstimatifLineDrawer
        }, null, 8, ["estimatif-line", "categories-selected", "tvas", "unites", "onAddToLines", "onUpdateEstimatifLine", "onClose"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_set_tva_modal, {
      parameters: _ctx.modalSetTvaParameters,
      "onUpdate:parameters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalSetTvaParameters) = $event)),
      onSetTva: _ctx.setTvas
    }, null, 8, ["parameters", "onSetTva"]),
    _createVNode(_component_modify_categorie_modal, {
      "modify-categorie-parameters": _ctx.modalModifyCategorieParameters,
      "onUpdate:modify-categorie-parameters": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalModifyCategorieParameters) = $event)),
      onUpdateCategorie: _ctx.updateEstimatifLineCategorie
    }, null, 8, ["modify-categorie-parameters", "onUpdateCategorie"]),
    _createVNode(_component_price_evolution_modal, {
      "price-evolution": _ctx.modalPriceEvolutionData,
      "onUpdate:price-evolution": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalPriceEvolutionData) = $event)),
      onUpdatePrices: _ctx.updatePrices
    }, null, 8, ["price-evolution", "onUpdatePrices"]),
    _createVNode(_component_move_line_modal, {
      parameters: _ctx.modalMoveLineParameters,
      "onUpdate:parameters": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalMoveLineParameters) = $event)),
      min: 1,
      max: _ctx.estimatifLines.length,
      onMoveLine: _ctx.moveLine
    }, null, 8, ["parameters", "max", "onMoveLine"])
  ]))
}